<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>MS Word的Trinka外掛程式
                            <span>僅限高級</span>
                        </h1>
                        <p>微軟Word的Trinka外掛程式使有效的寫作變得更簡單！Trinka會自動檢查您的寫作，並在您熟悉的Word應用程式中進行修改。</p>
                        <div id="MacMSWordButton">
                            <button title="適用於 Mac OS 的 Word 插件即將推出">
                                <img src="../../../assets/images/safari_logo.png" alt="safari logo">
                                即將推出
                            </button>
                            <span><a href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank">*從此處下載適用於 Windows 的加載項。</a></span>
                        </div>
                        <div class="wordPluginCTA"  id="MSWindowDownloadButton">
                            <b id="windowInfo64bit"></b>
                            <i class="betaTagText">Beta</i>
                        </div>
                        <span id="MSWindowTextContent">*與Windows系統Word 2010以上版本相容</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/MSWordBanner.png" alt="ms word">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="how_it_work_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="how_it_work_content">
                        <div class="howItWorkHeading">
                            <h2>工作原理</h2>
                            <div class="HeadingSubLine"></div>    
                        </div>
                        <ul>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="" style="width: 50px; height: 50px;">
                                </div>
                                <h3>下載</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/TypeOrImportFile_icon.png" alt="">
                                </div>
                                <h3>安裝</h3>
                            </li>
                            <li>
                                <div class="login_circle_section">
                                    <img src="../../../assets/images/improveYourWriting_icon.png" alt="">
                                </div>
                                <h3>開始提升寫作</h3>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider accomplishSections">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="accomplishSections_img">

                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="../../../assets/images/microsoft-wordThumbnails.jpg" alt="trinka on word" class="img-fluid eposter-img">
                            <!-- <img src="https://i.ytimg.com/vi/uNNpxOtvJ80/maxresdefault.jpg" alt=""> -->
                        </a>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="spellcheck_heading EnhancementsHeadingSection">
                        <h2>
                            在Windows作業系統上開始使用Word的Trinka外掛程式
                        </h2>
                        <div class="HeadingSubLine"></div>
                        <p>需要幫助安裝外掛程式嗎？或者想知道怎麼使用這個外掛程式更正您的寫作？
                        </p>
                        <p>您可以立即查看簡單的演練影片。
                        </p>
                        <p>如果您還有更多問題，
                            <a (click)="scroll(target)" class="link">請在此處</a>瀏覧,我們的常見問題解答。</p>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Trinka Microsoft Word外掛程式的主要功能</h2>
                        <div class="HeadingSubLine"></div>
                        <p>您可以在熟悉的MS Word應用程式中外掛Trinka，在寫作的同時獲得更正和建議。更棒的是它會自動檢查所有更改，因此您不會錯過任何內容！</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style guide icon">
                        <h3>風格指南設定</h3>
                        <p>根據常用的學術風格指南（AMA第11版，AGU 2017等等）調整手稿的文法和單詞選擇。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area document">
                        <h3>專業領域和文件類型</h3>
                        <p>根據專業領域和文件類型定製Trinka，為您提供最相關的建議。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AddtoDictionary.svg" alt="add to dictionary">
                        <h3>添加到詞典</h3>
                        <p>將自己的單詞添加到“我的詞典”中，這樣Trinka就不會在將來的寫作中將其標記為拼寫錯誤。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DataSecurityIcon.svg" alt="data secure">
                        <h3>資料安全</h3>
                        <p>您輸入的任何內容都會被安全地傳輸和分析，我們決不會保留您的資料。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/sendForHumanEditing.svg" alt="human editing">
                        <!-- <img src="../../../assets/images/ComingSoonTag.png" alt="" class="commingSoonTag_img"> -->
                        <h3>發送進行人工編輯</h3>
                        <p>需要專家為您的最終稿件進行人工編輯嗎？直接從Trinka編輯工具將其發送給英論閣的專家進行編輯。</p>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>常見問答</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        請問如何為微軟Word添加/安裝Trinka外掛程式？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在微軟Word的Trinka外掛程式頁面上，您可以找到“立即下載”按鈕。下載安裝文件後，按兩下它開始安裝過程，安裝成功後打開微軟Word應用程式。您在頂部的功能區上可以找到一個名為Trinka的新選項卡。按一下選項卡並點擊”登錄”，使用您的高級帳戶登錄就開始使用Trinka了。</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">如何在Word中打開Trinka語法檢查功能？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>下載並安裝微軟Word的Trinka外掛程式後，您只需要使用您的Trinka帳戶憑據登錄，然後按一下功能區功能表上Trinka選項卡上的“開始”按鈕即可開始Trinka語法檢查。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        在微軟Word上安裝Trinka外掛程式的系統要求是什麼？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>微軟Word的Trinka外掛程式適用於Windows上的微軟Word 2010及更高版本，Mac版微軟 Word外掛程式即將推出。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        我可以在Mac上使用微軟Word的Trinka外掛程式嗎？
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Mac上的微軟Word外掛程式正在開發中，即將推出。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        微軟Word的Trinka外掛程式是否即時檢查拼寫和語法？
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的，微軟Word的Trinka外掛程式會即時檢查並提出更正建議。此外，它會檢測您所做的任何更改，並立即重新檢查您的寫作並進行更正。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        如何接受或拒絕建議？
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>接受或拒絕建議非常容易。只需按一下建議的單詞就可以接受或者應用更正，或按一下“拇指向下”的這個圖示就可以拒絕建議。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        我可以在微軟Word的Trinka外掛程式裡面選擇在美國英語和英國英語之間進行切換嗎？
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的。您可以從功能區功能表上的語言檢查和設置功能表選項裡面，選擇在美國英語和英國英語之間進行切換。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        在微軟Word的Trinka外掛程式中，我可以選擇格式指南嗎？
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>是的。您可以從功能區功能表上的語言檢查和設置功能表選項中選擇預設格式指南。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        我沒有安裝微軟Word，而是使用Google Docs、Medium等線上寫作，那麼該如何使用Trinka？
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在您喜愛的網站上，您可以使用我們開發的適用於Chrome、Firefox和Edge瀏覽器的Trinka瀏覽器外掛程式，
                                            <a href="/browser-plugin">點擊這裡</a>下載瀏覽器的Trinka外掛程式。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                        安裝成功後找不到Word的Trinka外掛程式怎麼辦？
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>在某些情況下，您的系統/單位安全可以禁用載入項的啟動。您可以嘗試從文件->選項->載入項->管理->COM-載入項來手動啟用它。您可以
                                            <a href="https://youtu.be/RDrzQOBNAsk" target="_blank">觀看此影片</a>以瞭解詳細的流程。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question11">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true"
                                        aria-controls="Question11Content">
                                        如果微軟Word的Trinka外掛程式無法檢測到寫作錯誤，那該怎麼辦？
                                    </a>
                                </div>

                                <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以嘗試以下幾個步驟來解決問題：</p>
                                        <ul>
                                            <li>請檢查您的互聯網連接。您需要連接到互聯網才能讓Trinka檢測錯誤並提出更正建議。</li>
                                            <li>檢查外掛程式是否因為您的系統/單位的安全設置而被禁用。
                                            </li>
                                            <li>嘗試卸載並重新安裝外掛程式。</li>
                                            <li>如果問題仍然存在，請發送電子郵件至
                                                <a href="mailto:support@trinka.ai">support@trinka.ai</a> ，我們的團隊將幫助您解決問題。</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>在其他應用程式
                                    <br />中使用Trinka</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <div class="app_name_content" routerLink="/trinkacloud">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                        <h3>Trinka Cloud</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" routerLink="/browser-plugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/other_Apps_browser.svg" alt="browser">
                                        <h3>瀏覽器
                                            <br />外掛程式</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise apps">
                                        <h3 style="margin: 0 0 -2px 0;">企業</h3>
                                        <span style="font-size: 10px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/cTo16u94rxc"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>